import React from 'react';

// SVG-mask shape: a gently wavy horizontal band. preserveAspectRatio="none"
// stretches it across the container, so the undulation reads as wide and slow.
const WAVE_MASK =
  "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 20' preserveAspectRatio='none'><path d='M0,3 Q25,0 50,3 T100,3 L100,17 Q75,20 50,17 T0,17 Z' fill='black'/></svg>\")";

const LivingWatercolorRiver = () => (
    <div
        className="w-full h-16 md:h-24 relative z-20 overflow-hidden"
        style={{
            WebkitMaskImage: WAVE_MASK,
            maskImage: WAVE_MASK,
            WebkitMaskSize: '100% 100%',
            maskSize: '100% 100%',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
        }}
    >
        {/* 200%-wide gradient band, translated -50% per cycle — seamless loop
            because stops at 0% and 50% share the same color. Pure transform
            animation: one composite layer, no per-frame paint. */}
        <div
            className="absolute top-0 left-0 h-full"
            style={{
                width: '200%',
                background: `linear-gradient(90deg,
                    var(--color-accent-blue),
                    var(--color-accent-pink),
                    var(--color-accent-gold),
                    var(--color-accent-green),
                    var(--color-accent-blue),
                    var(--color-accent-pink),
                    var(--color-accent-gold),
                    var(--color-accent-green),
                    var(--color-accent-blue))`,
                animation: 'ribbonShift 25s linear infinite',
                willChange: 'transform',
                opacity: 0.75,
            }}
        />
    </div>
);

export default LivingWatercolorRiver;
